import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDoubleArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 13.2998L13.5996 8.7002L9 4.09961L10.4004 2.7002L16.4004 8.7002L10.4004 14.7002L9 13.2998ZM2 13.2998L6.59961 8.7002L2 4.09961L3.40039 2.7002L9.40039 8.7002L3.40039 14.7002L2 13.2998Z" })
});
export default SvgDoubleArrowRight;
